/// <reference path="../app.js"/>

class VideoCarouselBehaviour {
	static init() {
		$(".VideoCarouselElement").each(function() {
			$(this).find(".carousel").slick({
				variableWidth: true,
				prevArrow: null,
				autoplaySpeed: 5000,
				autoplay: true,
				nextArrow: $(this).find(".next")
			});
		});

		return;

		$(".VideoCarouselElement .image").each(function() {
			let self = $(this);

			this.style.backgroundImage = `url(https://img.youtube.com/vi/${self.parent().attr("data-embed").match(/embed\/[^\"]+/g).map(str => str.replace("embed/", ""))[0]}/0.jpg)`;
		});

		$(".VideoCarouselElement .slide").on("click", function() {
			let s = $(this);
			$("#"+s.data("open")).html('<div class="responsive-embed widescreen">'+s.data("embed")+'</div>');
		});

		$(document).on("closed.zf.reveal", ".video-carousel-reveal", function() {
			$(this).html("");
		});
	}
}
